if (!customElements.get('custom-dropdown')) {
  class Dropdown extends HTMLElement {
    constructor() {
      super();
      this.toggleButton = null;
      this.content = null;
      this.screenWidth = window.innerWidth;
      this.dropdownId = this.getAttribute('id'); // Get the dropdown's ID
    }

    connectedCallback() {
      this.toggleButton = this.querySelector('[data-toggle]');
      this.content = this.querySelector('[data-content]');
      window.dropdownStates = window.dropdownStates || {};
      
      if (!this.toggleButton || !this.content) return;

      this.toggleButton.setAttribute('aria-haspopup', 'true');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('role', 'menu');
      this.content.setAttribute('tabindex', '-1');

      Object.assign(this.content.style, {
        maxHeight: '400px',
        overflowY: 'auto',
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        zIndex: '1',
        background: 'var(--color-primary-light, #fff)',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'opacity 0.2s ease',
        width: 'max-content'
      });

      // Check if the dropdown was previously open using its ID
      if (window.dropdownStates && window.dropdownStates[this.dropdownId] === 'open') {
        this.openDropdown();
      }

      this.addEventListener('click', e => {
        if (e.target.closest('[data-toggle]')) {
          const isActive = this.classList.toggle('active');
          this.toggleButton.setAttribute('aria-expanded', isActive);
          if (isActive) {
            this.adjustPosition();
            window.dropdownStates[this.dropdownId] = 'open'; // Save the open state by ID
          } else {
            window.dropdownStates[this.dropdownId] = 'closed'; // Save the closed state by ID
          }
        }
      });

      this.addEventListener('mouseleave', () => this.closeDropdown());

      document.addEventListener('click', e => {
        if (!this.contains(e.target)) this.closeDropdown();
      });
    }

    disconnectedCallback() {
      // Save the state when the dropdown is removed from the DOM
      if (this.dropdownId) {
        window.dropdownStates = window.dropdownStates || {};
        window.dropdownStates[this.dropdownId] = this.classList.contains('active') ? 'open' : 'closed';
      }
    }

    openDropdown() {
      this.classList.add('active');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.adjustPosition();
    }

    closeDropdown() {
      this.classList.remove('active');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      window.dropdownStates[this.dropdownId] = 'closed'; // Save the closed state by ID
    }

    adjustPosition() {
      const dropdownRect = this.getBoundingClientRect();
      const contentRect = this.content.getBoundingClientRect();
      const margin = 8;
      const maxWidth = this.screenWidth - 16;
    
      let contentWidth = contentRect.width;
      if (contentWidth > maxWidth) {
        contentWidth = maxWidth;
        this.content.style.width = `${contentWidth}px`;
      }
    
      let leftOffset = dropdownRect.left;
      let overflowRight = leftOffset + contentWidth > this.screenWidth;

      if (overflowRight) {
        let shiftLeft = leftOffset + contentWidth + 8 - this.screenWidth;
        let maxShiftLeft = leftOffset - margin;
        this.content.style.left = `-${Math.min(shiftLeft, maxShiftLeft)}px`;
      } else {
        this.content.style.left = '0px';
      }
    }    
  }

  customElements.define('custom-dropdown', Dropdown);
}
